import { Tag } from '@nx-frontend/shared/types';

export function generateTagId(tag: string) {
  let hash = 0;
  for (let i = 0; i < tag.length; i++) {
    hash = (hash << 5) - hash + tag.charCodeAt(i);
    hash |= 0;
  }
  return (hash >>> 0).toString(16);
}

export function tagsNamesComparator(a: string, b: string) {
  return a.localeCompare(b);
}

export function tagsComparator(a: Tag, b: Tag) {
  return tagsNamesComparator(a.name, b.name);
}
